export const patternAccordionFaqs = () => {
  const $items = $('.pattern-accordion-faq__item');
  $items
    .wrapInner(`<details class="pattern-accordion-faq__item" />`)
    .children(0)
    .unwrap()
    .children()
    .children()
    .unwrap();

  const $headings = $('.pattern-accordion-faq__item > .wp-block-heading');
  $headings.wrap(`<summary />`);
};

export const patternAccordionProjects = () => {
  $('.pattern-accordion-projects__list .wp-block-post')
    .addClass('pattern-accordion-projects__list-item')
    .each((_, item) => {
      const container = $(
        '<div class="pattern-accordion-projects__list-item__content">'
      );
      const content = $(item).find(
        '> *:not(.wp-block-post-featured-image, .wp-block-projects-location, .wp-block-post-title)'
      );
      $(container).append(content);
      $(item).append(container);
    });

  const $headings = $(
    '.pattern-accordion-projects__list-item > .wp-block-post-title'
  );
  $headings.on('click', function () {
    $(this).parent()[0]?.toggleAttribute('open');
  });
};
